/**
 * Les libellés du journal : une phrase par action écrite dans `platform_audit`,
 * et un nom lisible pour les champs de leurs métadonnées.
 *
 * Une action absente d'ici s'afficherait en code brut (`CONNEXION_REUSSIE`) :
 * `journal.test.ts` lit les actions que l'API peut écrire et échoue si l'une
 * d'elles n'a pas son libellé, en français comme en anglais.
 */

export const actionsJournalFr = {
  CONSOLE_IA_COUPURE: 'Coupures IA modifiées',
  CONSOLE_IA_GALERIE: 'Réglages IA de la galerie modifiés',
  IA_VOIX_MODIFIEE: 'Voix IA de la galerie modifiée',
  CONSOLE_ADDON_ATTRIBUE: 'Droit add-on attribué',
  CONSOLE_ADDON_PROLONGE: 'Droit add-on prolongé',
  CONSOLE_ADDON_CONVERTI: 'Droit add-on converti',
  CONSOLE_ADDON_RETIRE: 'Droit add-on retiré',
  CONSOLE_ADDON_PUBLICATION: 'Publication add-on modifiée',
  CONSOLE_ADDON_REMISE: 'Remise d’add-on modifiée',
  CONSOLE_FACTURATION_VENIO_REGLAGES: 'Réglages de facturation Venio modifiés',
  CONSOLE_ADDON_ENCAISSEMENT: 'Encaissement d’une facture d’add-ons saisi',
  CONSOLE_ADDON_ENCAISSEMENT_ANNULE: 'Encaissement d’une facture d’add-ons annulé',
  CONSOLE_ADDON_FACTURE_RENVOYEE: 'Facture d’add-ons remise à l’envoi',
  CONSOLE_ADDON_PRIX: 'Prix d’un add-on modifié',
  CONSOLE_COEUR_PRIX: 'Prix d’un palier modifié',
  ABONNEMENT_CREATION: 'Abonnement au cœur créé',
  ABONNEMENT_RENOUVELLEMENT: 'Abonnement au cœur renouvelé ou arrêté',
  ABONNEMENT_PERIODE_OFFERTE: 'Période d’abonnement au cœur offerte',
  ABONNEMENT_RESILIATION: 'Résiliation de l’abonnement au cœur modifiée',
  CONSOLE_ABONNEMENT_RESILIATION: 'Résiliation de l’abonnement au cœur modifiée en console',
  ABONNEMENT_PALIER: 'Palier de l’abonnement au cœur modifié',
  CONSOLE_ABONNEMENT_PALIER: 'Palier de l’abonnement au cœur modifié en console',
  MARKETPLACE_PAIEMENT: 'État du paiement marketplace modifié',
  MARKETPLACE_COMMANDE: 'Essai d’add-on commandé',
  MARKETPLACE_RENOUVELLEMENT: 'Location d’add-on renouvelée ou arrêtée',
  MARKETPLACE_RESILIATION: 'Résiliation d’add-on modifiée',
  CONSOLE_ADDON_SUSPENSION: 'Souscription suspendue pour impayé',
  CONSOLE_ADDON_REACTIVATION: 'Souscription réactivée',
  CONSOLE_ADDON_AVOIR: 'Avoir Venio émis',
  CONSOLE_ADDON_REMBOURSEMENT_EN_LIGNE: 'Remboursement en ligne d’add-ons',
  CONSOLE_ADDON_REMBOURSEMENT: 'Remboursement d’un trop-perçu d’add-ons enregistré',
  CONSOLE_ADDON_RESILIATION: 'Résiliation d’add-on modifiée en console',
  CONSOLE_FICHE_FACTURATION: 'Fiche de facturation modifiée par Venio',
  FICHE_FACTURATION_MODIFIEE: 'Fiche de facturation modifiée par la galerie',
  // Journal de galerie du pipeline de ventes (add-on 1) : ses codes figurent
  // dans le code de l'API, la console doit savoir les dire.
  PIPELINE_AFFAIRE_CREEE: 'Affaire créée',
  PIPELINE_AFFAIRE_MODIFIEE: 'Affaire modifiée',
  PIPELINE_OFFRE_CREEE: 'Offre créée depuis une affaire',
  PIPELINE_RESERVATION_CREEE: 'Réservation créée depuis une affaire',
  PIPELINE_ATTENTE_AJOUTEE: 'Place ajoutée en liste d’attente',
  PIPELINE_ATTENTE_REORDONNEE: 'Liste d’attente réordonnée',
  PIPELINE_REGLAGES_MODIFIES: 'Réglages du pipeline modifiés',
  // Pilotage de la galerie (add-on 22).
  PILOTAGE_COUT_CREE: 'Coût d’exposition ajouté',
  PILOTAGE_COUT_MODIFIE: 'Coût d’exposition modifié',
  PILOTAGE_COUT_SUPPRIME: 'Coût d’exposition supprimé',
  PILOTAGE_REGLAGES_MODIFIES: 'Réglages du pilotage modifiés',
  // Boîte de réception (add-on 8).
  BOITE_MESSAGE_ENVOYE: 'Message envoyé depuis la boîte de réception',
  BOITE_ALIAS_REGENERE: 'Adresse de réception régénérée',
  BOITE_REGLAGES_MODIFIES: 'Réglages de la boîte de réception modifiés',
  ASSISTANT_REGLAGES_MODIFIES: 'Réglages de l’assistant de réponse modifiés',
  ASSISTANT_SENSIBLE_LEVE: 'Marque « sensible » levée sur une conversation',

  // Authentification
  CONNEXION_REUSSIE: 'Connexion réussie',
  CONNEXION_ECHOUEE: 'Échec de connexion',
  COMPTE_VERROUILLE: 'Compte verrouillé après plusieurs échecs',
  DECONNEXION: 'Déconnexion',
  MOT_DE_PASSE_DEMANDE: 'Réinitialisation du mot de passe demandée',
  MOT_DE_PASSE_REINITIALISE: 'Mot de passe réinitialisé',
  CGU_ACCEPTEES: 'Conditions d’utilisation acceptées',
  CGU_REFUSEES: 'Conditions d’utilisation refusées',
  DIRECTION_PLATEFORME_AMORCEE: 'Direction de la plateforme créée',
  SEMIS_TEST_RECUPERE: 'Semis des comptes de test récupéré après interruption',
  SSO_CONNEXION_REUSSIE: 'Connexion unique réussie',
  SSO_CONNEXION_REFUSEE: 'Connexion unique refusée',
  SSO_IDENTITE_LIEE: 'Identité externe liée à un compte',
  SSO_IDENTITE_DELIEE: 'Identité externe déliée d’un compte',
  MFA_ENROLEMENT: 'Double authentification : enrôlement commencé',
  MFA_CONFIRME: 'Double authentification activée',
  MFA_DESACTIVE: 'Double authentification désactivée',
  MFA_CODE_SECOURS_UTILISE: 'Code de secours utilisé',
  MFA_CODES_SECOURS_REGENERES: 'Codes de secours régénérés',
  INVITATION_EMISE: 'Invitation envoyée',
  INVITATION_ACCEPTEE: 'Invitation acceptée',
  JETON_AUTH_ECHOUEE: 'Jeton d’accès refusé',
  JETON_EMIS: 'Jeton d’accès émis',
  JETON_REVOQUE: 'Jeton d’accès révoqué',
  JETON_MUTATION: 'Écriture par jeton d’accès',
  // Galeries et provisionnement
  GALERIE_CREEE: 'Galerie créée',
  GALERIE_PROVISIONNEMENT_REPRIS: 'Provisionnement de la galerie repris',
  CONSOLE_GALERIE_CREEE: 'Galerie provisionnée',
  CONSOLE_PROVISIONNEMENT_REPRIS: 'Provisionnement repris',
  // Dossiers d'ouverture (ARTO-127)
  CONSOLE_OUVERTURE_CREEE: 'Dossier d’ouverture créé',
  CONSOLE_OUVERTURE_MODIFIEE: 'Dossier d’ouverture modifié',
  CONSOLE_OUVERTURE_CONTRAT_SIGNE: 'Ouverture : contrat signé',
  CONSOLE_OUVERTURE_PROVISIONNE: 'Ouverture : galerie provisionnée',
  CONSOLE_OUVERTURE_REPRISE: 'Ouverture : reprise des données commencée',
  CONSOLE_OUVERTURE_RECETTE: 'Ouverture : recette commencée',
  CONSOLE_OUVERTURE_BASCULE_PLANIFIEE: 'Ouverture : bascule planifiée',
  CONSOLE_OUVERTURE_EN_SERVICE: 'Ouverture : galerie en service',
  CONSOLE_OUVERTURE_ABANDONNE: 'Ouverture abandonnée',
  CONSOLE_OUVERTURE_CONTRAT: 'Contrat signé déposé',
  CONSOLE_OUVERTURE_GALERIE_CREEE: 'Galerie créée depuis son dossier d’ouverture',
  CONSOLE_GALERIE_MODIFIEE: 'Fiche modifiée',
  CONSOLE_GALERIE_RESILIEE: 'Galerie résiliée',
  CONSOLE_GALERIE_TEST_MODIFIEE: 'Marquage d’espace de test modifié',
  DEMANDE_SITE_ENVOYEE: 'Demande de création de site envoyée',
  CONSOLE_DEMANDE_SITE_MODIFIEE: 'Demande de création de site mise à jour',
  // Demandes d'ouverture venues d'artosera.com (ARTO-188)
  CONSOLE_DEMANDE_OUVERTURE_QUALIFIEE: 'Demande d’ouverture qualifiée',
  CONSOLE_DEMANDE_OUVERTURE_PERDUE: 'Demande d’ouverture marquée perdue',
  CONSOLE_DEMANDE_OUVERTURE_MODIFIEE: 'Demande d’ouverture modifiée (responsable ou note)',
  CONSOLE_DEMANDE_OUVERTURE_CONVERTIE: 'Demande d’ouverture convertie en dossier',
  DEMANDES_OUVERTURE_PURGEES: 'Demandes d’ouverture anciennes purgées',
  CONSOLE_INVITATION_RENVOYEE: 'Invitation de la direction renvoyée',
  CONSOLE_APPARENCE_MODIFIEE: 'Thème de la régie modifié',
  CONSOLE_VERSION_APP_MODIFIEE: 'Versions des apps mobiles modifiées',
  // Domaines
  CONSOLE_DOMAINE_AJOUTE: 'Domaine ajouté',
  CONSOLE_DOMAINE_VERIFIE: 'Domaine vérifié',
  CONSOLE_DOMAINE_DESACTIVE: 'Domaine retiré',
  CONSOLE_DOMAINE_PRINCIPAL: 'Domaine principal désigné',
  // Modules, interrupteurs, paliers
  CONSOLE_MODULE_ACTIVE: 'Module activé',
  CONSOLE_MODULE_DESACTIVE: 'Module désactivé',
  GALERIE_MODULE_ACTIVE: 'Module activé par la galerie',
  GALERIE_MODULE_DESACTIVE: 'Module désactivé par la galerie',
  CONSOLE_INTERRUPTEUR_COUPE: 'Module coupé pour toutes les galeries',
  CONSOLE_INTERRUPTEUR_RETABLI: 'Module rétabli pour toutes les galeries',
  CONSOLE_PALIER_DEBLOQUE: 'Module débloqué (palier)',
  CONSOLE_PALIER_VERROUILLE: 'Module verrouillé (palier)',
  // Exports, sauvegardes, travaux, purge
  CONSOLE_EXPORT_DEMANDE: 'Export demandé',
  CONSOLE_EXPORT_RENVOYE: 'Export renvoyé à la direction de la galerie',
  CONSOLE_TEST_RESTAURATION_DEMANDE: 'Test de restauration demandé',
  CONSOLE_TRAVAIL_RELANCE: 'Travail relancé',
  CONSOLE_PURGE_LANCEE: 'Purge lancée',
  CONSOLE_PURGE_FORCEE: 'Purge forcée',
  CONSOLE_PURGE_REPRISE_SUPERVISEE: 'Purge reprise sous supervision',
  CONSOLE_OPERATIONS_REMISES_A_ZERO: 'Opérations en cours remises à zéro',
  CONSOLE_HISTORIQUE_DEPOTS_VERIFIE: 'Historique des dépôts vérifié',
  EXPORT_PRODUIT: 'Export complet produit',
  EXPORT_ECHOUE: 'Export complet échoué',
  EXPORT_TELECHARGE: 'Export téléchargé',
  EXPORT_ACCUSE: 'Réception de l’export accusée',
  GALERIE_PURGEE: 'Galerie purgée',
  GALERIE_EFFACEE: 'Données de la galerie effacées',
  COMPTE_EFFACE: 'Compte effacé',
  PURGE_BLOQUEE: 'Purge bloquée',
  // Accès de support
  ACCES_SUPPORT_DEMANDE: 'Accès de support demandé',
  ACCES_SUPPORT_ACCORDE: 'Accès de support accordé',
  ACCES_SUPPORT_REFUSE: 'Accès de support refusé',
  ACCES_SUPPORT_REVOQUE: 'Accès de support révoqué',
  ACCES_SUPPORT_UTILISE: 'Accès de support utilisé',
  // Reprise des données
  MANDAT_REPRISE_POSE: 'Mandat de reprise posé par contrat',
  MANDAT_REPRISE_DEMANDE: 'Mandat de reprise demandé',
  MANDAT_REPRISE_ACCORDE: 'Mandat de reprise accordé',
  MANDAT_REPRISE_REFUSE: 'Mandat de reprise refusé',
  MANDAT_REPRISE_REVOQUE: 'Mandat de reprise révoqué',
  MANDAT_REPRISE_ECOURTE: 'Mandat de reprise écourté à la bascule',
  CONSOLE_REPRISE_DEPOT: 'Lot de reprise déposé',
  CONSOLE_REPRISE_ESSAI: 'Essai d’un lot de reprise lancé',
  CONSOLE_REPRISE_LANCEE: 'Lot de reprise lancé',
  CONSOLE_REPRISE_DEPOT_OUVERT: 'Dépôt de reprise ouvert',
  CONSOLE_REPRISE_LIEN_CREE: 'Lien de dépôt créé',
  CONSOLE_REPRISE_LIEN_REVOQUE: 'Lien de dépôt révoqué',
  REPRISE_SOURCES_PURGEES: 'Sources de reprise purgées',
  CONSOLE_REPRISE_CONNECTEUR_AUTORISE: 'Accès Dropbox autorisé pour la reprise',
  CONSOLE_REPRISE_CONNECTEUR_SOURCE: 'Dossier Dropbox à importer choisi',
  CONSOLE_REPRISE_CONNECTEUR_LANCE: 'Import Dropbox lancé',
  CONSOLE_REPRISE_CONNECTEUR_REVOQUE: 'Accès Dropbox révoqué',
  CONSOLE_REPRISE_PROFILAGE: 'Profilage d’un lot de reprise lancé',
  CONSOLE_REPRISE_TRANSFORMATION: 'Transformation d’un lot de reprise lancée',
  CONSOLE_REPRISE_CORRESPONDANCE: 'Correspondance d’un lot de reprise modifiée',
  CONSOLE_PROFIL_CREE: 'Profil de correspondance créé',
  CONSOLE_PROFIL_VERSION: 'Nouvelle version d’un profil de correspondance',
  CONSOLE_REPRISE_PLAN: 'Plan de reprise lancé',
  CONSOLE_REPRISE_PAUSE: 'Plan de reprise suspendu',
  CONSOLE_REPRISE_ECARTEE: 'Lignes refusées écartées d’un lot de reprise',
  CONSOLE_REPRISE_ANNULEE: 'Annulation d’un lot de reprise demandée',
  CONSOLE_REPRISE_SCELLEE: 'Reprise scellée',
  CONSOLE_RECETTE_CONTROLE: 'Recette : liste de contrôle mise à jour',
  CONSOLE_RECETTE_DEROGATION: 'Recette : dérogation de la direction de Venio',
  CONSOLE_REPRISE_BASCULE: 'Bascule : étape faite',
  REPRISE_RECETTE_VALIDEE: 'Reprise validée par la galerie',
  REPRISE_RECETTE_SIGNALEE: 'Problème de reprise signalé par la galerie',
  REPRISE_PV_PRODUIT: 'Procès-verbal de reprise produit',
  // Pilotage financier et associés
  CONSOLE_TARIF_ECRIT: 'Tarif saisi',
  CONSOLE_ABONNEMENT_ECRIT: 'Abonnement saisi',
  CONSOLE_REVENU_ECRIT: 'Revenu ponctuel saisi',
  CONSOLE_CREANCE_ECRITE: 'Somme due saisie',
  CONSOLE_COUT_ECRIT: 'Coût saisi',
  CONSOLE_JALON_ECRIT: 'Jalon saisi',
  CONSOLE_PARTAGE_ECRIT: 'Partage saisi',
  CONSOLE_VERSEMENT_ECRIT: 'Versement saisi',
  CONSOLE_ASSOCIE_INVITE: 'Associé invité',
  CONSOLE_ASSOCIE_MODIFIE: 'Associé modifié',
  CONSOLE_REPARTITION_ECRITE: 'Grille de répartition saisie',
  CONSOLE_MOIS_CLOTURE: 'Mois comptable clôturé',
  CONSOLE_MOIS_ROUVERT: 'Mois comptable rouvert',
  CONSOLE_EXCLUSION_ECRITE: 'Galerie exclue de la part d’un bénéficiaire (ajout ou retrait)',
  CONSOLE_TYPE_RECETTE_ECRIT: 'Type de recette créé, modifié ou supprimé',
  RELEVE_ASSOCIE_ENVOYE: 'Relevé mensuel envoyé à un associé',
  RELEVES_RATTRAPES: 'Relevés d’associés réenvoyés par le rattrapage',
  // Connecteurs, équipe, groupe
  CONNECTEUR_CONFIGURE: 'Connecteur configuré',
  CONNECTEUR_RETIRE: 'Connecteur retiré',
  CONNECTEUR_VERIFIE: 'Connecteur vérifié',
  CONNECTEURS_RECHIFFRES: 'Secrets des connecteurs rechiffrés',
  EQUIPE_ROLE_MODIFIE: 'Rôle d’un membre modifié',
  EQUIPE_DROITS_MODIFIES: 'Droits d’un membre modifiés',
  GROUPE_CONSOLE_CONSULTEE: 'Groupe consulté depuis la console',
};

export const actionsJournalEn: Record<keyof typeof actionsJournalFr, string> = {
  CONSOLE_IA_COUPURE: 'AI shutdowns updated',
  CONSOLE_IA_GALERIE: 'Gallery AI settings updated',
  IA_VOIX_MODIFIEE: 'Gallery AI voice updated',
  CONSOLE_ADDON_ATTRIBUE: 'Add-on entitlement granted',
  CONSOLE_ADDON_PROLONGE: 'Add-on entitlement extended',
  CONSOLE_ADDON_CONVERTI: 'Add-on entitlement converted',
  CONSOLE_ADDON_RETIRE: 'Add-on entitlement withdrawn',
  CONSOLE_ADDON_PUBLICATION: 'Add-on publication changed',
  CONSOLE_ADDON_REMISE: 'Add-on discount changed',
  CONSOLE_FACTURATION_VENIO_REGLAGES: 'Venio billing settings changed',
  CONSOLE_ADDON_ENCAISSEMENT: 'Add-on invoice receipt recorded',
  CONSOLE_ADDON_ENCAISSEMENT_ANNULE: 'Add-on invoice receipt cancelled',
  CONSOLE_ADDON_FACTURE_RENVOYEE: 'Add-on invoice queued for resending',
  CONSOLE_ADDON_PRIX: 'Add-on price changed',
  CONSOLE_COEUR_PRIX: 'Plan price changed',
  ABONNEMENT_CREATION: 'Core subscription created',
  ABONNEMENT_RENOUVELLEMENT: 'Core subscription renewed or stopped',
  ABONNEMENT_PERIODE_OFFERTE: 'Complimentary core subscription period',
  ABONNEMENT_RESILIATION: 'Core subscription cancellation changed',
  CONSOLE_ABONNEMENT_RESILIATION: 'Core subscription cancellation changed in console',
  ABONNEMENT_PALIER: 'Core subscription plan changed',
  CONSOLE_ABONNEMENT_PALIER: 'Core subscription plan changed in console',
  MARKETPLACE_PAIEMENT: 'Marketplace payment status changed',
  MARKETPLACE_COMMANDE: 'Add-on trial ordered',
  MARKETPLACE_RENOUVELLEMENT: 'Add-on rental renewed or stopped',
  MARKETPLACE_RESILIATION: 'Add-on cancellation changed',
  CONSOLE_ADDON_SUSPENSION: 'Subscription suspended for non-payment',
  CONSOLE_ADDON_REACTIVATION: 'Subscription reactivated',
  CONSOLE_ADDON_AVOIR: 'Venio credit note issued',
  CONSOLE_ADDON_REMBOURSEMENT_EN_LIGNE: 'Online add-on refund',
  CONSOLE_ADDON_REMBOURSEMENT: 'Add-on overpayment refund recorded',
  CONSOLE_ADDON_RESILIATION: 'Add-on cancellation changed in console',
  CONSOLE_FICHE_FACTURATION: 'Billing details changed by Venio',
  FICHE_FACTURATION_MODIFIEE: 'Billing details changed by the gallery',
  PIPELINE_AFFAIRE_CREEE: 'Deal created',
  PIPELINE_AFFAIRE_MODIFIEE: 'Deal updated',
  PIPELINE_OFFRE_CREEE: 'Offer created from a deal',
  PIPELINE_RESERVATION_CREEE: 'Reservation created from a deal',
  PIPELINE_ATTENTE_AJOUTEE: 'Waiting list entry added',
  PIPELINE_ATTENTE_REORDONNEE: 'Waiting list reordered',
  PIPELINE_REGLAGES_MODIFIES: 'Pipeline settings updated',
  PILOTAGE_COUT_CREE: 'Exhibition cost added',
  PILOTAGE_COUT_MODIFIE: 'Exhibition cost updated',
  PILOTAGE_COUT_SUPPRIME: 'Exhibition cost deleted',
  PILOTAGE_REGLAGES_MODIFIES: 'Gallery insights settings updated',
  BOITE_MESSAGE_ENVOYE: 'Message sent from the inbox',
  BOITE_ALIAS_REGENERE: 'Receiving address regenerated',
  BOITE_REGLAGES_MODIFIES: 'Inbox settings updated',
  ASSISTANT_REGLAGES_MODIFIES: 'Reply assistant settings updated',
  ASSISTANT_SENSIBLE_LEVE: '“Sensitive” flag lifted on a conversation',
  CONNEXION_REUSSIE: 'Signed in',
  CONNEXION_ECHOUEE: 'Sign-in failed',
  COMPTE_VERROUILLE: 'Account locked after several failures',
  DECONNEXION: 'Signed out',
  MOT_DE_PASSE_DEMANDE: 'Password reset requested',
  MOT_DE_PASSE_REINITIALISE: 'Password reset',
  CGU_ACCEPTEES: 'Terms of use accepted',
  CGU_REFUSEES: 'Terms of use declined',
  DIRECTION_PLATEFORME_AMORCEE: 'Platform direction created',
  SEMIS_TEST_RECUPERE: 'Test account seeding recovered after an interruption',
  SSO_CONNEXION_REUSSIE: 'Single sign-on succeeded',
  SSO_CONNEXION_REFUSEE: 'Single sign-on refused',
  SSO_IDENTITE_LIEE: 'External identity linked to an account',
  SSO_IDENTITE_DELIEE: 'External identity unlinked from an account',
  MFA_ENROLEMENT: 'Two-factor authentication: setup started',
  MFA_CONFIRME: 'Two-factor authentication enabled',
  MFA_DESACTIVE: 'Two-factor authentication disabled',
  MFA_CODE_SECOURS_UTILISE: 'Backup code used',
  MFA_CODES_SECOURS_REGENERES: 'Backup codes regenerated',
  INVITATION_EMISE: 'Invitation sent',
  INVITATION_ACCEPTEE: 'Invitation accepted',
  JETON_AUTH_ECHOUEE: 'Access token refused',
  JETON_EMIS: 'Access token issued',
  JETON_REVOQUE: 'Access token revoked',
  JETON_MUTATION: 'Write through an access token',
  GALERIE_CREEE: 'Gallery created',
  GALERIE_PROVISIONNEMENT_REPRIS: 'Gallery provisioning resumed',
  CONSOLE_GALERIE_CREEE: 'Gallery provisioned',
  CONSOLE_PROVISIONNEMENT_REPRIS: 'Provisioning resumed',
  CONSOLE_OUVERTURE_CREEE: 'Onboarding file created',
  CONSOLE_OUVERTURE_MODIFIEE: 'Onboarding file modified',
  CONSOLE_OUVERTURE_CONTRAT_SIGNE: 'Onboarding: contract signed',
  CONSOLE_OUVERTURE_PROVISIONNE: 'Onboarding: gallery provisioned',
  CONSOLE_OUVERTURE_REPRISE: 'Onboarding: data migration started',
  CONSOLE_OUVERTURE_RECETTE: 'Onboarding: acceptance started',
  CONSOLE_OUVERTURE_BASCULE_PLANIFIEE: 'Onboarding: switchover scheduled',
  CONSOLE_OUVERTURE_EN_SERVICE: 'Onboarding: gallery live',
  CONSOLE_OUVERTURE_ABANDONNE: 'Onboarding abandoned',
  CONSOLE_OUVERTURE_CONTRAT: 'Signed contract uploaded',
  CONSOLE_OUVERTURE_GALERIE_CREEE: 'Gallery created from its onboarding file',
  CONSOLE_GALERIE_MODIFIEE: 'Record modified',
  CONSOLE_GALERIE_RESILIEE: 'Gallery terminated',
  CONSOLE_GALERIE_TEST_MODIFIEE: 'Test space mark changed',
  DEMANDE_SITE_ENVOYEE: 'Website creation request sent',
  CONSOLE_DEMANDE_SITE_MODIFIEE: 'Website creation request updated',
  CONSOLE_DEMANDE_OUVERTURE_QUALIFIEE: 'Opening request qualified',
  CONSOLE_DEMANDE_OUVERTURE_PERDUE: 'Opening request marked as lost',
  CONSOLE_DEMANDE_OUVERTURE_MODIFIEE: 'Opening request modified (owner or note)',
  CONSOLE_DEMANDE_OUVERTURE_CONVERTIE: 'Opening request converted into an onboarding file',
  DEMANDES_OUVERTURE_PURGEES: 'Old opening requests purged',
  CONSOLE_INVITATION_RENVOYEE: 'Management invitation resent',
  CONSOLE_APPARENCE_MODIFIEE: 'Back-office theme changed',
  CONSOLE_VERSION_APP_MODIFIEE: 'Mobile app versions changed',
  CONSOLE_DOMAINE_AJOUTE: 'Domain added',
  CONSOLE_DOMAINE_VERIFIE: 'Domain verified',
  CONSOLE_DOMAINE_DESACTIVE: 'Domain removed',
  CONSOLE_DOMAINE_PRINCIPAL: 'Primary domain set',
  CONSOLE_MODULE_ACTIVE: 'Module turned on',
  CONSOLE_MODULE_DESACTIVE: 'Module turned off',
  GALERIE_MODULE_ACTIVE: 'Module turned on by the gallery',
  GALERIE_MODULE_DESACTIVE: 'Module turned off by the gallery',
  CONSOLE_INTERRUPTEUR_COUPE: 'Module switched off for every gallery',
  CONSOLE_INTERRUPTEUR_RETABLI: 'Module restored for every gallery',
  CONSOLE_PALIER_DEBLOQUE: 'Module unlocked (tier)',
  CONSOLE_PALIER_VERROUILLE: 'Module locked (tier)',
  CONSOLE_EXPORT_DEMANDE: 'Export requested',
  CONSOLE_EXPORT_RENVOYE: 'Export sent again to the gallery’s direction',
  CONSOLE_TEST_RESTAURATION_DEMANDE: 'Test restore requested',
  CONSOLE_TRAVAIL_RELANCE: 'Job retried',
  CONSOLE_PURGE_LANCEE: 'Purge started',
  CONSOLE_PURGE_FORCEE: 'Purge forced',
  CONSOLE_PURGE_REPRISE_SUPERVISEE: 'Purge resumed under supervision',
  CONSOLE_OPERATIONS_REMISES_A_ZERO: 'Running operations reset',
  CONSOLE_HISTORIQUE_DEPOTS_VERIFIE: 'Deposit history verified',
  EXPORT_PRODUIT: 'Full export produced',
  EXPORT_ECHOUE: 'Full export failed',
  EXPORT_TELECHARGE: 'Export downloaded',
  EXPORT_ACCUSE: 'Export receipt acknowledged',
  GALERIE_PURGEE: 'Gallery purged',
  GALERIE_EFFACEE: 'Gallery data erased',
  COMPTE_EFFACE: 'Account erased',
  PURGE_BLOQUEE: 'Purge blocked',
  ACCES_SUPPORT_DEMANDE: 'Support access requested',
  ACCES_SUPPORT_ACCORDE: 'Support access granted',
  ACCES_SUPPORT_REFUSE: 'Support access declined',
  ACCES_SUPPORT_REVOQUE: 'Support access revoked',
  ACCES_SUPPORT_UTILISE: 'Support access used',
  // Data migration
  MANDAT_REPRISE_POSE: 'Migration mandate set by contract',
  MANDAT_REPRISE_DEMANDE: 'Migration mandate requested',
  MANDAT_REPRISE_ACCORDE: 'Migration mandate granted',
  MANDAT_REPRISE_REFUSE: 'Migration mandate refused',
  MANDAT_REPRISE_REVOQUE: 'Migration mandate revoked',
  MANDAT_REPRISE_ECOURTE: 'Migration mandate shortened at switchover',
  CONSOLE_REPRISE_DEPOT: 'Migration batch uploaded',
  CONSOLE_REPRISE_ESSAI: 'Migration batch dry run started',
  CONSOLE_REPRISE_LANCEE: 'Migration batch launched',
  CONSOLE_REPRISE_DEPOT_OUVERT: 'Migration upload opened',
  CONSOLE_REPRISE_LIEN_CREE: 'Upload link created',
  CONSOLE_REPRISE_LIEN_REVOQUE: 'Upload link revoked',
  REPRISE_SOURCES_PURGEES: 'Migration sources purged',
  CONSOLE_REPRISE_CONNECTEUR_AUTORISE: 'Dropbox access authorized for migration',
  CONSOLE_REPRISE_CONNECTEUR_SOURCE: 'Dropbox folder to import chosen',
  CONSOLE_REPRISE_CONNECTEUR_LANCE: 'Dropbox import started',
  CONSOLE_REPRISE_CONNECTEUR_REVOQUE: 'Dropbox access revoked',
  CONSOLE_REPRISE_PROFILAGE: 'Migration batch profiling started',
  CONSOLE_REPRISE_TRANSFORMATION: 'Migration batch transformation started',
  CONSOLE_REPRISE_CORRESPONDANCE: 'Migration batch mapping changed',
  CONSOLE_PROFIL_CREE: 'Mapping profile created',
  CONSOLE_PROFIL_VERSION: 'Mapping profile version published',
  CONSOLE_REPRISE_PLAN: 'Migration plan launched',
  CONSOLE_REPRISE_PAUSE: 'Migration plan suspended',
  CONSOLE_REPRISE_ECARTEE: 'Rejected rows set aside from a migration batch',
  CONSOLE_REPRISE_ANNULEE: 'Migration batch rollback requested',
  CONSOLE_REPRISE_SCELLEE: 'Migration sealed',
  CONSOLE_RECETTE_CONTROLE: 'Acceptance: checklist updated',
  CONSOLE_RECETTE_DEROGATION: 'Acceptance: waiver by Venio management',
  CONSOLE_REPRISE_BASCULE: 'Switchover: step done',
  REPRISE_RECETTE_VALIDEE: 'Migration accepted by the gallery',
  REPRISE_RECETTE_SIGNALEE: 'Migration issue reported by the gallery',
  REPRISE_PV_PRODUIT: 'Migration acceptance report produced',
  CONSOLE_TARIF_ECRIT: 'Price entered',
  CONSOLE_ABONNEMENT_ECRIT: 'Subscription entered',
  CONSOLE_REVENU_ECRIT: 'One-off revenue entered',
  CONSOLE_CREANCE_ECRITE: 'Amount due entered',
  CONSOLE_COUT_ECRIT: 'Cost entered',
  CONSOLE_JALON_ECRIT: 'Milestone entered',
  CONSOLE_PARTAGE_ECRIT: 'Profit share entered',
  CONSOLE_VERSEMENT_ECRIT: 'Payout entered',
  CONSOLE_ASSOCIE_INVITE: 'Partner invited',
  CONSOLE_ASSOCIE_MODIFIE: 'Partner updated',
  CONSOLE_REPARTITION_ECRITE: 'Revenue split rule entered',
  CONSOLE_MOIS_CLOTURE: 'Accounting month closed',
  CONSOLE_MOIS_ROUVERT: 'Accounting month reopened',
  CONSOLE_EXCLUSION_ECRITE: 'Gallery excluded from a beneficiary’s share (added or removed)',
  CONSOLE_TYPE_RECETTE_ECRIT: 'Revenue type created, changed or deleted',
  RELEVE_ASSOCIE_ENVOYE: 'Monthly statement sent to a partner',
  RELEVES_RATTRAPES: 'Partner statements resent by the catch-up',
  CONNECTEUR_CONFIGURE: 'Connector configured',
  CONNECTEUR_RETIRE: 'Connector removed',
  CONNECTEUR_VERIFIE: 'Connector verified',
  CONNECTEURS_RECHIFFRES: 'Connector secrets re-encrypted',
  EQUIPE_ROLE_MODIFIE: 'Member role changed',
  EQUIPE_DROITS_MODIFIES: 'Member rights changed',
  GROUPE_CONSOLE_CONSULTEE: 'Group viewed from the console',
};

/** Les noms lisibles des champs de métadonnées (`jobId` → « Travail »). */
export const champsJournalFr = {
  coupee: 'IA coupée',
  usagesCoupes: 'Usages IA coupés',
  suspendue: 'IA suspendue',
  plafondMensuelCents: 'Plafond mensuel (cents USD)',
  valeur: 'Valeur',
  raison: 'Raison',
  minutes: 'Durée (minutes)',
  galeries: 'Galeries',
  origine: 'Origine',
  role: 'Rôle',
  roleConsole: 'Rôle de l’acteur',
  compteExistant: 'Compte existant',
  compteId: 'Compte',
  module: 'Module',
  modulesActifs: 'Modules actifs',
  motif: 'Motif',
  portee: 'Portée',
  palier: 'Palier',
  etat: 'État',
  etatPrecedent: 'État précédent',
  erreurPrecedente: 'Erreur précédente',
  quotas: 'Quotas',
  jobId: 'Travail',
  exportJobId: 'Export',
  envoyer: 'Envoi à la direction',
  expireLe: 'Expire le',
  purgePossibleLe: 'Purge possible le',
  destinataires: 'Destinataires',
  transmis: 'Transmis',
  operation: 'Opération',
  champs: 'Champs',
  ressource: 'Ressource',
  demandeId: 'Demande',
  par: 'Par',
  depots: 'Dépôts',
  generation: 'Génération',
  precedent: 'Précédent',
  principal: 'Principal',
  invitationsRevoquees: 'Invitations révoquées',
  revoquees: 'Invitations révoquées',
  sessionsRevoquees: 'Sessions fermées',
  emetteur: 'Fournisseur d’identité',
  connecteur: 'Connecteur',
  octets: 'Octets',
  sha256: 'Empreinte (SHA-256)',
  complet: 'Complet',
  final: 'Export final',
  message: 'Message',
  erreur: 'Erreur',
  completes: 'Étapes reprises',
  estTest: 'Espace de test',
  langue: 'Langue',
  direction: 'Direction',
  email: 'Adresse e-mail',
  sousDomaine: 'Sous-domaine',
  reprise: 'Reprise',
  alerte: 'Alerte',
  hote: 'Domaine',
  index: 'Numéro',
  mois: 'Mois',
  depuisMois: 'À partir de',
  galerieId: 'Galerie',
  rectifie: 'Rectifié',
  beneficiaires: 'Bénéficiaires',
  script: 'Script d’exploitation',
  mandatId: 'Mandat',
  natures: 'Natures',
  confidentiels: 'Documents confidentiels',
  reference: 'Référence',
  dureeJours: 'Durée (jours)',
  lotId: 'Lot',
  nature: 'Nature',
  importId: 'Import',
  fichiers: 'Fichiers',
  lignes: 'Lignes',
  plateforme: 'Plateforme',
  minimale: 'Version minimale',
  conseillee: 'Version conseillée',
  urlBoutique: 'Fiche dans la boutique',
};

export const champsJournalEn: Record<keyof typeof champsJournalFr, string> = {
  coupee: 'AI switched off',
  usagesCoupes: 'Disabled AI usages',
  suspendue: 'AI suspended',
  plafondMensuelCents: 'Monthly limit (USD cents)',
  valeur: 'Value',
  raison: 'Reason',
  minutes: 'Duration (minutes)',
  galeries: 'Galleries',
  origine: 'Origin',
  role: 'Role',
  roleConsole: 'Actor’s role',
  compteExistant: 'Existing account',
  compteId: 'Account',
  module: 'Module',
  modulesActifs: 'Enabled modules',
  motif: 'Reason given',
  portee: 'Scope',
  palier: 'Tier',
  etat: 'State',
  etatPrecedent: 'Previous state',
  erreurPrecedente: 'Previous error',
  quotas: 'Quotas',
  jobId: 'Job',
  exportJobId: 'Export',
  envoyer: 'Sent to the direction',
  expireLe: 'Expires on',
  purgePossibleLe: 'Purge possible on',
  destinataires: 'Recipients',
  transmis: 'Delivered',
  operation: 'Operation',
  champs: 'Fields',
  ressource: 'Resource',
  demandeId: 'Request',
  par: 'By',
  depots: 'Deposits',
  generation: 'Generation',
  precedent: 'Previous',
  principal: 'Primary',
  invitationsRevoquees: 'Invitations revoked',
  revoquees: 'Invitations revoked',
  sessionsRevoquees: 'Sessions closed',
  emetteur: 'Identity provider',
  connecteur: 'Connector',
  octets: 'Bytes',
  sha256: 'Fingerprint (SHA-256)',
  complet: 'Complete',
  final: 'Final export',
  message: 'Message',
  erreur: 'Error',
  completes: 'Steps resumed',
  estTest: 'Test space',
  langue: 'Language',
  direction: 'Direction',
  email: 'Email address',
  sousDomaine: 'Subdomain',
  reprise: 'Resumed',
  alerte: 'Alert',
  hote: 'Domain',
  index: 'Number',
  mois: 'Month',
  depuisMois: 'Starting',
  galerieId: 'Gallery',
  rectifie: 'Corrected',
  beneficiaires: 'Beneficiaries',
  script: 'Operations script',
  mandatId: 'Mandate',
  natures: 'Kinds of data',
  confidentiels: 'Confidential documents',
  reference: 'Reference',
  dureeJours: 'Duration (days)',
  lotId: 'Batch',
  nature: 'Kind of data',
  importId: 'Import',
  fichiers: 'Files',
  lignes: 'Rows',
  plateforme: 'Platform',
  minimale: 'Minimum version',
  conseillee: 'Recommended version',
  urlBoutique: 'Store page',
};
